import Vue from "vue";
// import "vant/lib/index.css";
import App from "./App.vue";
import router from "./router/index";
// import "@/assets/style/font/iconfont.css";
import "@/assets/style/index.less";
import $axios from "@/api/request";
import mixin from "./mixin/index";
import store from "./store/index";
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import "@/components/Vant";
// rem
import "amfe-flexible";
let wx = window.wx; // index.html中引入外部js，获取js暴露的wx
console.log(wx,'wx=========') //wx对象可以正常输出
// 把变量挂载到vue的原型上
Vue.prototype.$axios = $axios;
Vue.mixin(mixin);

Vue.config.productionTip = false;

Vue.use(Element)

// var vConsole = new VConsole();
// console.log('Hello world');

const isProd =true //是否生产环境
let http = isProd ? 'https://boschqrmp.bshg.com.cn/' : 'https://boschcstest.bshg.com.cn/'
let authHttp = isProd ? 'https://boschqrmp.bshg.com.cn/boschqreshopapi' : 'https://boschcstest.bshg.com.cn/boschqreshopapi'
let agentId = isProd ? '1000494' : '1000088' //生产应用1000264  测试应用  69
Vue.prototype.$http = http
Vue.prototype.$authHttp = authHttp
Vue.prototype.$agentId = agentId
console.log("是否是生产环境:",isProd)
console.log("是否是生产环境http:",http)
console.log("是否是生产环境authHttp:",authHttp)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
